import React, {FC, useEffect, useState} from 'react'

type TimerProps = {
  seconds: number
}

export const Timer: FC<TimerProps> = ({seconds}) => {
  const [timer, setTimer] = useState(seconds)

  const time = [Math.floor(timer / 60 / 60), Math.floor(timer / 60 % 60), timer % 60]
    .map((item) => item.toString().padStart(2, '0'))
    .join(':')

  useEffect(() => {
    const interval = setInterval(() => setTimer(state => state - 1), 1000)

    return () => clearInterval(interval)
  }, [])

  return (
    <>{time}</>
  )
}